module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Bag-chair-29eebafcd511bbea001e7b6842a952d0.svg";